import { computed, onBeforeUnmount, Ref, ref, watch } from 'vue';

const PROGRESS_DURATION = 10000;
const PROGRESS_INTERVAL = 100;

// コンポーネントをまたいで進行状況を共有するためのMap
const progressMap = new Map<number, { startTime: number }>();

export const useFeedSummaryProgress = (summaryId: Ref<number | undefined>) => {
  let timerId: number | undefined = undefined;

  const startTime = ref(0);
  const currentTime = ref(0);
  const progressBarWidth = computed(() => {
    const percent =
      ((currentTime.value - startTime.value) / PROGRESS_DURATION) * 100;
    return `${Math.min(100, Math.max(0, percent))}%`;
  });

  const stopProgress = () => {
    window.clearInterval(timerId);
    if (summaryId.value !== undefined) {
      progressMap.delete(summaryId.value);
    }
  };

  const startProgress = () => {
    window.clearInterval(timerId);
    startTime.value = +new Date();

    // 同じ要約の進行状況があればそれを引き継ぐ
    if (summaryId.value !== undefined) {
      const existing = progressMap.get(summaryId.value);
      if (existing) {
        startTime.value = existing.startTime;
      }
    }

    timerId = window.setInterval(() => {
      currentTime.value = +new Date();

      if (currentTime.value - startTime.value >= PROGRESS_DURATION) {
        stopProgress();
      }
    }, PROGRESS_INTERVAL);
  };

  // summaryIdは生成直後はundefinedなので、summaryIdが得られたときに保存する
  watch(summaryId, id => {
    if (id !== undefined) {
      progressMap.set(id, { startTime: startTime.value });
    }
  });

  onBeforeUnmount(() => window.clearInterval(timerId));

  return {
    progressBarWidth,
    startProgress,
    stopProgress,
  };
};
